import en from "./en-US";
import es from "./es-UY";

export default {
    ...en,
    ...es,
};
